"use client";

import { ReactNode, useContext } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";

export const HighlightedResourceCardClickLogger = ({
  children,
  resourceType,
  slug,
  title,
}: {
  children: ReactNode;
  resourceType: HighlightedResourceVM["resourceType"];
  slug: string;
  title: string;
}) => {
  const { logView } = useContext(ResourceContext);
  const handleClick = () => {
    logEvent("home_highlighted_resource_click", logView, {
      highlighted_resource_type: resourceType,
      highlighted_resource_slug: slug,
      highlighted_resource_title: title,
    });
  };

  return (
    <div onClickCapture={handleClick} className="contents">
      {children}
    </div>
  );
};
